import * as typeform from '@typeform/embed-react';

const { PopupButton } = typeform;

// eslint-disable-next-line  @typescript-eslint/no-unsafe-assignment
const FORM_ID: string = (import.meta.env || process.env)
  ?.VITE_TYPEFORM_PARTNER_REFERRAL;

export function MarketplaceButton({
  key,
  cssClass,
  text,
  dataTestId,
}: {
  key: string;
  cssClass: string;
  text: string;
  dataTestId: string;
}) {
  return (
    <div className='my-3 flex items-center mb-4'>
      <PopupButton
        id={FORM_ID}
        className={cssClass}
        key={`typeform_${key}`}
        data-testid={dataTestId}
      >
        {text}
      </PopupButton>
    </div>
  );
}
